import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import OfficeInfo from './OfficeInfo';
import FullScreenMessage from "./FullScreenMessage";
import './AvailableTimes.css';
import { cqAPI } from "../lib/Auth";
import moment from 'moment-timezone';

const Availabilities = () => {
  const { serviceId } = useParams();
  const [hasError, setHasError] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [availability, setAvailability] = useState([]);
  const [selectedOption, setSelectedOption] = useState('');
  const [service, setService] = useState({})
  const [officeData, setOfficeData] = useState({ });
  const [isLoading, setIsLoading] = useState(true);  // State to handle loading

  useEffect(() => {
    cqAPI.get(`/times?service_id=${serviceId}&timepref=${selectedOption}`)
      .then(data => {
        if (data.type === 'ok') {
          setAvailability(data.data.availabilities);
          setService(data.data.service)
          setOfficeData(data.data.business)
        } else {
          if (data.code) {
            setHasError(true);
          }
        }
        setIsLoading(false);
      })
      .catch(error => {
        setHasError(true);
        setIsLoading(false);
        console.error('Loading error', error);
      });
  }, [serviceId, selectedOption]);

  const handleOptionChange = (event) => {
    setIsLoading(true);
    setSelectedOption(event.target.value);
  };
  
  const handleDayClick = (date)=>{
    const formattedDate = new Date(date).toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric'
    }).replace(/\//g, '-');

    const searchParams = new URLSearchParams(location.search);
    searchParams.set('timepref', selectedOption);

    navigate({
      pathname: `/service/${serviceId}/${formattedDate}`,
      search: `?${searchParams.toString()}`
    });
  }
  
  const changeService = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete('timepref');

    navigate({
      pathname: `/`,
      search: `?${searchParams.toString()}`
    });
  };
  
  if (hasError) {
    return <FullScreenMessage message="This is not a valid link" />;
  }
  
  if (isLoading) {
    return (
      <div className="spinner-container">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="availability-container">
      <OfficeInfo info={officeData} />
      <div className="service-header">
        <span className="selected-service">{service.name}</span>
        <span className="change-service" onClick={changeService}>Change service</span>
      </div>
      <div className="appointment-selector">
        <h2>When would you like to come in?</h2>
        <form>
          <label>
            <input
              type="radio"
              value=""
              checked={selectedOption === ''}
              onChange={handleOptionChange}
            />
            Earliest
          </label>
          <label>
            <input
              type="radio"
              value="morning"
              checked={selectedOption === 'morning'}
              onChange={handleOptionChange}
            />
            Morning
          </label>
          <label>
            <input
              type="radio"
              value="afternoon"
              checked={selectedOption === 'afternoon'}
              onChange={handleOptionChange}
            />
            Afternoon
          </label>
        </form>
      </div>
      {availability.map((dayInfo, index) => (
        <div key={index} className="day-block" onClick={()=>handleDayClick(dayInfo.date)}>
          <div className="date-header">
            <h3>{`${moment(new Date(dayInfo.date)).tz(officeData.zone).format('dddd, MM/DD/YYYY')}`}</h3>
          </div>
          {renderProviders(dayInfo)}
        </div>
      ))}
    </div>
  );
};

const renderProviders = (dayInfo) => {
  const providerElements = [];
  for (let i = 0; dayInfo[`provider${i}_name`]; i++) {
    providerElements.push(
      <div className="provider-info" key={i}>
        <img src={dayInfo[`provider${i}_img`]} alt={dayInfo[`provider${i}_name`]} className="provider-img" />
        <div>
          <h4>{dayInfo[`provider${i}_name`]}</h4>
          <p>{dayInfo[`provider${i}_desc`]}</p>
        </div>
      </div>
    );
  }
  return providerElements;
};

export default Availabilities;
